import React from 'react';
import { Title } from '../../atoms';
import T from 'prop-types';

export const ErrorWrapper = ({ text }) => {
    return <div className={'errorWrapperCls'}>
        <Title className={'wrapperTextCls'} text={text} />
    </div>;
};

ErrorWrapper.T = {
    text: T.string,
};

